import React, { useCallback, useState, useEffect, useRef } from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import { RepairView } from './repair-view';
import { carRepairs } from 'src/api/cars/vm-view';
import PageSection from 'src/layouts/page-section';

const Page = ({ onNavigate, item, options }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const hasFetched = useRef(false);

  const [data, setData] = useState([]);
  const fetchData = useCallback(async (myId) => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    
    try {
      let number = (item.lastKm) ? parseInt(item.lastKm.replace(/,/g, ''), 10) : 0;
      const result = await carRepairs(myId, options, number);
      setData(result);
    } catch (error) {
      
    } finally {
      hasFetched.current = false;
    }
  }, []);

  useEffect(() => {
    if(item && options){
      fetchData(item.id);
    }
  }, [fetchData]);

  return (
    <PageSection title="Car Repairs" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.carManagement)}
        />
        <Stack spacing={1}>
          <RepairView item={item} services={data} />
        </Stack>
      </Stack>
    </PageSection>
  );
};

export default Page;
